// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEbsSnapshotsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-ebs-snapshots_svga)" d="M40 0H0v40h40z" />
    <svg width={21} height={28} x={9.5} y={6} viewBox="0 0 21 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m17.98 18.35.05-.37q.48.32.68.5-.3-.02-.73-.13m-8.59-2.71q.01-.11.13-.12l.05.02-.1.19q-.07-.02-.08-.09m6.36 9.75s-.11.24-.87.54q-.51.21-1.22.36c-1.2.28-2.67.44-4.14.44-3.69 0-6.05-.88-6.23-1.3v-.1L1.51 12.27l.1.04q.31.15.67.28l.05.02a11 11 0 0 0 1.8.5l.17.04.94.16.23.04.78.1q.12 0 .23.03l.96.08.16.01.79.05h.24a26 26 0 0 0 1.75 0h.24l.8-.05h.16l.95-.1.24-.02.77-.1.24-.04.93-.16.18-.04a16 16 0 0 0 1.8-.5l.05-.02q.34-.13.66-.28l.1-.04-.77 5.73a58 58 0 0 1-6.09-2.51 1.15 1.15 0 1 0-.55 1.15q4.05 1.95 6.47 2.65zM9.52 8.24c4.88 0 8.15 1.53 8.24 2.19l-.01.06q0 .03-.04.06l-.03.06-.07.08-.07.06-.1.08-.1.07-.13.07-.13.08-.16.07-.17.09-.17.07-.22.08-.2.07-.24.09-.22.06-.28.08-.25.07-.3.08-.3.06-.32.07-.31.05-.35.06-.36.05-.36.06-.4.04-.36.04-.46.04-.36.02-.52.03-.34.01a30 30 0 0 1-1.82 0l-.34-.01-.53-.03-.33-.02-.49-.04-.32-.04-.44-.04-.32-.05-.4-.06-.3-.05-.36-.06-.3-.07-.31-.07-.27-.06-.29-.08-.24-.07-.26-.07-.22-.08-.22-.08-.2-.07-.19-.08-.16-.08-.16-.08-.13-.07-.14-.08-.1-.07-.1-.08-.06-.06q-.05-.04-.07-.08l-.04-.05-.04-.07v-.06c.09-.66 3.35-2.2 8.24-2.2M20.19 18.5c-.11-.59-.71-1.16-1.98-1.9l.8-5.88.02-.18v-.09c0-2.08-4.92-3.49-9.51-3.49S0 8.36 0 10.46v.08l.03.18 1.99 14.75C2.1 27.33 6.52 28 9.52 28c1.56 0 3.14-.16 4.43-.46q.8-.18 1.4-.42 1.62-.65 1.67-1.65l.79-5.88q.6.1 1.03.11.81 0 1.13-.37.3-.37.22-.83M2.95 7.32H1.67V5.65c0-.35.29-.64.64-.64h14.47c.36 0 .64.29.64.64v1.67h-1.27V6.29H2.95zm2.21-6.05h8.77l1.4 1.51H3.77zM2.31 4.06h14.47a.64.64 0 0 0 .47-1.07L14.68.2a.6.6 0 0 0-.47-.2H4.88a.6.6 0 0 0-.47.2L1.84 3a.64.64 0 0 0 .47 1.07"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-ebs-snapshots_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEbsSnapshots",
);
export default AwsEbsSnapshotsIcon;
